<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle" :isBg="false"></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="from-wrap">
          <div class="set-wrap">
            <div class="set-title">收货人</div>
            <div class="set-info">
              <div class="set-input">
                <!-- <input type="text" value="" placeholder="请输入姓名" v-model="name" /> -->

                <el-input v-model="name" placeholder="请输入姓名"></el-input>
              </div>
            </div>
          </div>
          <div class="set-wrap">
            <div class="set-title">手机号</div>
            <div class="set-info">
              <div class="set-input">
                <!-- <input type="text" value="" placeholder="请输入手机号" v-model="idcard" /> -->
                <el-input
                  type="number"
                  v-model="phone"
                  placeholder="请输入手机号"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </div>
            </div>
          </div>
          <div class="set-wrap">
            <div class="set-title">城市/区域</div>
            <div class="set-info">
              <div class="address-select">
                <div class="address-item">
                  <el-select
                    v-model="province"
                    placeholder="省"
                    @change="provinceClick"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="address-item">
                  <el-select
                    v-model="city"
                    placeholder="市"
                    @change="cityClick"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="address-item">
                  <el-select v-model="county" placeholder="区">
                    <el-option
                      v-for="item in countyList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="set-wrap">
            <div class="set-title">详细地址</div>
            <div class="set-textarea">
              <el-input
                type="textarea"
                placeholder="街道/区域"
                v-model="address"
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </div>
          </div>

          <div class="set-wrap">
            <div
              class="radio-wrap"
              @click="
                parseInt(isdefault) === 1 ? (isdefault = 0) : (isdefault = 1)
              "
            >
              <span
                class="icon"
                :class="{ active: parseInt(isdefault) === 1 }"
              ></span
              >设为默认收货地址
            </div>
          </div>
          
          <div class="set-btn2">
            <van-button @click="submit()" :loading="isLoading" :disabled="isLoading" loading-text="保 存"  >保 存</van-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import cityDate from "../../../assets/js/libs/city";
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Dialog, Toast, Button } from "vant";

import { Input, Select, Option, OptionGroup } from "element-ui";

Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Button);

Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);

export default {
  name: "user-address-edit",
  data() {
    return {
      isLoading:false,
      
      id: this.$route.query.id ? this.$route.query.id : "",

      name: "",
      phone: "",

      isdefault: 0,

      provinceList: [],
      cityList: [],
      countyList: [],

      province: "",
      city: "",
      county: "",
      address: "",
    };
  },
  components: {
    SubHeader,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
    // console.log(cityDate);
    let provinceList = [];
    for (let i in cityDate) {
      let obj = {};
      obj.code = cityDate[i].code;
      obj.name = cityDate[i].name;
      provinceList.push(obj);
    }
    this.provinceList = provinceList;

    

    if (this.id) {
      if (this.addressList.length > 0) {
        console.log(this.addressList);
        let addressList = this.addressList;
        if (addressList.length > 0) {
          for (let i in addressList) {
            if (addressList[i].id === this.id) {
              // console.log(addressList[i]);
              this.provinceClick(addressList[i].province);
              this.cityClick(addressList[i].city);
              this.province = addressList[i].province;
              this.name = addressList[i].name;
              this.phone = addressList[i].phone;
              this.isdefault = addressList[i].isdefault;
              this.city = addressList[i].city;
              this.county = addressList[i].county;
              this.address = addressList[i].address;
            }
          }
        }
      } else {
        this.getAddress({
          success: (res) => {
            console.log(res);
            if (res.status === 1) {
              if (res.address_list.length > 0) {
                for (let i in res.address_list) {
                  if (res.address_list[i].id === this.id) {
                    // console.log(res.address_list[i]);

                    this.provinceClick(res.address_list[i].province);
                    this.cityClick(res.address_list[i].city);

                    this.province = res.address_list[i].province;
                    this.name = res.address_list[i].name;
                    this.phone = res.address_list[i].phone;
                    this.isdefault = res.address_list[i].isdefault;
                    this.city = res.address_list[i].city;
                    this.county = res.address_list[i].county;
                    this.address = res.address_list[i].address;
                  }
                }
              }
            }
          },
        });
      }
    }

    // console.log(this.id);
  },
  methods: {
    ...mapActions({
      getAddress: "address/getAddress",
      addAddress: "address/addAddress",
      updateAddress: "address/updateAddress",
    }),

    provinceClick(val) {
      console.log(val);

      this.city = "";
      this.county = "";
      let cityList = [];
      for (let i in cityDate) {
        if (cityDate[i].name == val) {
          cityList = cityDate[i].children;
          break;
        }
      }
      this.cityList = cityList;

      // console.log(cityList)
    },
    cityClick(val) {
      console.log(val);

      this.county = "";
      let countyList = [];
      console.log(val);
      let cityList = this.cityList;
      for (let i in cityList) {
        if (cityList[i].name == val) {
          countyList = cityList[i].children;
        }
      }
      this.countyList = countyList;
    },

    submit() {
      let that = this;
      let name = this.name;
      let phone = this.phone;
      let province = this.province;
      let city = this.city;
      let county = this.county;
      let address = this.address;
      let isdefault = this.isdefault;

      if (this.name.match(/^\s*$/)) {
        Toast({ message: "请输入姓名" });
        return;
      }

      if (this.phone.match(/^\s*$/)) {
        Toast("请输入手机号");
        return;
      }
      if (!this.phone.match(/^1[0-9][0-9]\d{8}$/)) {
        Toast("您输入的手机号格式不正确");
        return;
      }

      if (
        this.province.match(/^\s*$/) ||
        this.city.match(/^\s*$/) ||
        this.county.match(/^\s*$/)
      ) {
        Toast({ message: "请选择城市" });
        return;
      }

      if (this.address.match(/^\s*$/)) {
        Toast({ message: "请输入详细地址" });
        return;
      }

      // let token =  this.$utils.md5(this.$utils.md5(guid+'|'+security+'|'+province+'|'+city+'|'+county)+'|'+address_key);

      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.isLoading = true;
      if (this.id) {
        let id = this.id;
        let data = {
          id,
          name,
          phone,
          province,
          city,
          county,
          address,
          isdefault,
        };
        this.updateAddress({
          data: data,
          success: (res) => {
            toastLoading.clear();
            that.isLoading = false;
            if (res.status == 1) {
              Toast("操作成功");
              that.$router.go(-1);
            } else {
              Toast(res.message);
            }
          },
        });
      } else {
        let data = {
          name,
          phone,
          province,
          city,
          county,
          address,
          isdefault,
        };
        this.addAddress({
          data: data,
          success: (res) => {
            toastLoading.clear();
            that.isLoading = false;
            if (res.status == 1) {
              Toast("操作成功");
              that.$router.go(-1);

            } else {
              Toast(res.message);
            }
          },
        });
      }
    },
  },
  computed: {
    ...mapState({
      addressList: (state) => state.address.address,
    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.from-wrap {
  padding-bottom: 1rem;
  overflow: hidden;
}

.set-wrap {
  margin-bottom: 0.3rem;
  .set-title {
    font-size: 0.3rem;
    color: #333234;
    line-height: 1rem;
    padding: 0 0.55rem;
    font-weight: bold;
  }
  .set-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    height: 0.8rem;
    padding: 0 0.28rem 0 0.55rem;

    .set-input {
      flex: 1;
      height: 100%;

      input {
        width: 100%;
        height: 100%;
        background: none;
        font-size: 0.3rem;
        color: #333234;
        &::-webkit-input-placeholder {
          color: #a0a0a0;
        }
      }
    }
  }
  .address-select {
    display: flex;
    align-items: center;
    margin: 0 -15px;
  }
  .radio-wrap {
    padding: 0 0.28rem 0 0.55rem;
    font-size: 0.26rem;
    color: #646464;
    display: flex;
    align-items: center;
    span {
      width: 0.33rem;
      height: 0.33rem;
      margin-right: 0.09rem;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url(../../../assets/images/user/set/ic1.png);
      background-size: 100%;
      &.active {
        background-image: url(../../../assets/images/user/set/ic1-on.png);
      }
    }
  }
}

.set-btn2 {
  margin-top: 1rem;
}

.set-tips {
  padding: 0.24rem 0.55rem;
  font-size: 0.24rem;
  color: #8c8c8c;
  text-align: center;
  line-height: 1.8;
}
</style>

<style lang="scss" >
.el-select {
  .el-input {
    .el-select__caret {
      color: #9c9c9c;
    }
  }
}
.set-input {
  .el-input__inner {
    padding: 0;
  }
}
.el-input {
  font-size: 0.3rem;
}
.el-input__inner {
  height: 0.8rem;
  line-height: 0.8rem;
  background: none;
  border: 0;
  color: #333234;
  &::-webkit-input-placeholder {
    color: #a0a0a0;
  }
}

body .el-select-dropdown__item.selected {
  color: #f07d18;
  background: #f2ebce;
}

.set-textarea {
  .el-textarea {
    .el-textarea__inner {
      border: 0;
      background: #d3d3d3;
      font-size: 0.3rem;
      color: #333234;
      padding: 0.2rem 0.28rem 0.55rem 0.55rem;
      border-radius: 0;
      height: 2.48rem;
      &::-webkit-input-placeholder {
        color: #a0a0a0;
      }
    }
    .el-input__count {
      font-size: 0.26rem;
      color: #a0a0a0;
      right: 0.28rem;
      background: #d3d3d3;
    }
  }
}
</style>